export const DECORATION_CLASS = 'inline-swatch';
export const HEX_DECORATION_CLASS = `${DECORATION_CLASS} inline-swatch-hex`;
